// The icon for each place in the menu (lucide, drawn at 1.75px stroke): the spine and Ask Ogma's cards use the same.
import { ChartColumn, Handshake, MessageCircle, Megaphone, ReceiptText, SlidersHorizontal, Sparkles, Users } from "lucide-react";
import type { KitIcon } from "./kit";

export const SECTION_ICONS: Record<string, KitIcon> = {
  ask: Sparkles,
  campaigns: Megaphone,
  conversations: MessageCircle,
  quotes: ReceiptText,
  contacts: Users,
  associations: Handshake,
  results: ChartColumn,
  settings: SlidersHorizontal,
};
